import React from 'react';

const AVAIL_SAMPLE = `{
  "shop": "齊文藝室 The Singularity",
  "month": "2026-08",
  "exported_at": "2026-08-20T12:00:00.000Z",
  "fulltime": ["姓名"],
  "parttime": ["姓名"],
  "submissions": {
    "姓名": {
      "person": "姓名",
      "identity_group": "fulltime|parttime",
      "month": "2026-08",
      "entries": [
        { "day": 1, "base": "can" },
        { "day": 2, "overrides": [{ "type": "range", "from": 12, "to": 17, "can": true }] },
        { "day": 3, "note": "備註" }
      ]
    }
  }
}`;

const SCHEDULE_SAMPLE = `{
  "month": "2026-08",
  "assignments": [
    {
      "day": 1,
      "person": "姓名",
      "start": 8,
      "end": 17,
      "label": "8-17",
      "counts_toward_counter": true
    }
  ],
  "violations": [],
  "needs_human_review": [],
  "monthly_stats": {
    "姓名": { "total_days": 10, "total_hours": 80 }
  }
}`;

const preStyle = {
  margin: '8px 0 0',
  padding: 10,
  background: '#f8fafc',
  border: '1px solid #e5e7eb',
  borderRadius: 8,
  fontSize: 11,
  lineHeight: 1.45,
  overflowX: 'auto',
  whiteSpace: 'pre',
};

export default function ScheduleFormatHelp({ kind = 'avail' }) {
  const isAvail = kind === 'avail';
  return (
    <details style={{ marginBottom: 12, fontSize: 13, color: '#4b5563' }}>
      <summary style={{ cursor: 'pointer', fontWeight: 700, color: '#374151' }}>
        {isAvail ? '可上 JSON 格式' : '班表匯入 JSON 格式'}
      </summary>
      {isAvail ? (
        <ul style={{ margin: '8px 0 0', paddingLeft: 18 }}>
          <li>entries 每筆只會有 base 或 overrides 其一</li>
          <li>submissions 缺人＝該月未送出，不可假設可上／不可上</li>
        </ul>
      ) : (
        <ul style={{ margin: '8px 0 0', paddingLeft: 18 }}>
          <li>時間用十進位小時；跨夜用大於 24（凌晨 1 點＝25）</li>
          <li>counts 為 counts_toward_counter 的簡寫</li>
        </ul>
      )}
      <pre style={preStyle}>{isAvail ? AVAIL_SAMPLE : SCHEDULE_SAMPLE}</pre>
    </details>
  );
}
